import React, { useCallback } from 'react'
import { withRouter, Link } from 'react-router-dom'

import './breadcrumb.css'

const TAB_NAMES = {
  '/catalog': 'Каталог',
  '/basket': 'Корзина',
  '/contacts': 'Контакти',
  '/delivery': 'Доставка',
  '/about_us': 'Про нас',
  '/warranty': 'Гарантія',
  '/news': 'Новини',
  '/how_to_order': 'Як замовити',
  '/order': 'Замовлення',
}

const Breadcrumb = (props) => {
  const { history: { location: { pathname } } } = props

  const showBreadCrumb = pathname !== '/'
  const splitedPathname = pathname.split('/')
  const [includesProducts, includesPage, includesOrder] = ['products', 'page', '/order'].map((item) => pathname.includes(item))

  const getItems = useCallback(() => {
    switch (true) {
      case includesPage:
      case includesProducts:
        return {
          name: splitedPathname[2],
        }
      default:
        return {
          name: TAB_NAMES[pathname] || splitedPathname[1]
        }
    }
  }, [pathname])

  return showBreadCrumb && (
    <nav aria-label='breadcrumb' className='breadcrumb__container'>
      <ol className='breadcrumb section__content'>
        <li className='breadcrumb-item' aria-current='page'>
          <Link to='/'>Головна</Link>
        </li>
        {includesProducts && (
          <li className='breadcrumb-item' aria-current='page'>
            <Link to='/catalog'>Каталог</Link>
          </li>
        )}
        {includesOrder && (
          <li className='breadcrumb-item' aria-current='page'>
            <Link to='/basket'>Корзина</Link>
          </li>
        )}
        <li className='breadcrumb-item active'>{getItems().name}</li>
      </ol>
    </nav>
  )
}

export default withRouter(Breadcrumb)